import * as h3 from 'h3-js';

export const getH3Index = (latitude, longitude, resolution) => {
    return h3.latLngToCell(latitude, longitude, resolution);
};

export const getGridDisk = (origin, k) => {
    return h3.gridDisk(origin, k)
}
